// extracted by mini-css-extract-plugin
export default {"container":"ISLwFmhXfMZekr2GxNQA"};